export default "__VITE_ASSET__BJj4KVG0__"